import { render, staticRenderFns } from "./choose-step-2.vue?vue&type=template&id=6940e23c&scoped=true&"
import script from "./choose-step-2.vue?vue&type=script&lang=js&"
export * from "./choose-step-2.vue?vue&type=script&lang=js&"
import style0 from "./choose-step-2.vue?vue&type=style&index=0&id=6940e23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940e23c",
  null
  
)

export default component.exports